import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatList, MatListItem, MatListItemLine, MatListItemTitle } from '@angular/material/list';

@Component({
  selector: 'ui-order-payment',
  templateUrl: './order-payment.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatList,
    MatListItem,
    MatListItemLine,
    MatListItemTitle,
  ],
})
export class OrderPaymentComponent {
}
